export default "__VITE_ASSET__CpotUkWz__"